import React, { useState, useEffect } from "react";
import moment from "moment";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

// Helper function for class names (you can also use a library like clsx)
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const LittleCalendarBordeless = ({
  currentMonth,
  selectedDay,
  generateDaysArray,
  setDayselected,
  appointments,
}) => {
  const [currentDate, setCurrentDate] = useState(moment(currentMonth));
  const [days, setDays] = useState([]);

  useEffect(() => {
    setDays(generateDaysArray(currentDate, selectedDay, appointments));
  }, [currentDate, selectedDay,appointments]);

  const handlePreviousMonth = () => {
    setCurrentDate(currentDate.clone().subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentDate(currentDate.clone().add(1, "month"));
  };


  return (
    <div className="rounded-lg border border-wa-border bg-wa-panel p-4 md:pr-8">
      <div className="flex items-center">
        <h2 className="flex-auto text-sm font-semibold text-wa-text">
          {moment(currentDate).locale('nl-be').format('MMMM YYYY')}
        </h2>
        <button
          type="button"
          onClick={handlePreviousMonth}
          className="-my-1.5 flex flex-none items-center justify-center p-1.5 text-wa-muted hover:text-wa-text"
        >
          <span className="sr-only">Previous month</span>
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
        </button>
        <button
          type="button"
          onClick={handleNextMonth}
          className="-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-wa-muted hover:text-wa-text"
        >
          <span className="sr-only">Next month</span>
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
      <div className="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-wa-muted">
        <div>Ma</div>
        <div>Di</div>
        <div>Wo</div>
        <div>DO</div>
        <div>Vr</div>
        <div>Za</div>
        <div>Zo</div>
      </div>
      <div className="mt-2 grid grid-cols-7 text-sm">
        {days.map((day, dayIdx) => (
          <div
            key={day.date}
            className={classNames(
              dayIdx > 6 && "border-t border-wa-border",
              "py-2"
            )}
          >
            <button
              type="button"
              onClick={()=>setDayselected(day)}
              className={classNames(
                day.isSelected && "text-white",
                day?.events?.length > 0 && "bg-wa-rowhover",
                !day.isSelected && day.isToday && "bg-wa-accent text-wa-onaccent",
                !day.isSelected &&
                  !day.isToday &&
                  day.isCurrentMonth &&
                  "text-wa-text",
                !day.isSelected &&
                  !day.isToday &&
                  !day.isCurrentMonth &&
                  "text-wa-muted",
                day.isSelected && day.isToday && "bg-wa-accent",
                day.isSelected && !day.isToday && "bg-wa-panel2",
                !day.isSelected && "hover:bg-wa-hover",
                (day.isSelected || day.isToday) && "font-semibold",
                "mx-auto flex h-8 w-8 items-center justify-center rounded-full"
              )}
            >
              <time dateTime={day?.date} className={
                classNames(
                  "mx-auto flex h-7 w-7 items-center justify-center rounded-full",
                  day.isSelected && day.isToday && "bg-wa-accent",
                  day?.events?.length > 0 && "bg-wa-accent text-wa-onaccent",
                  day.isToday && "bg-wa-accentdeep",
                  day.isCurrentMonth ? "text-wa-text" : "text-wa-muted"
                 
                )
              }>
                {day?.date.split("-").pop().replace(/^0/, "")}
              </time>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LittleCalendarBordeless;


